<template>
  <v-content class="">
    <section>
      <v-parallax
        :src="require('@/assets/beach-tsv2.jpg')"
        height="500"
        class="banner"
      >
        <Navbar></Navbar>

        <v-layout column class="white--text " justify-end>
          <div>
            <v-container justify-end>
              <div class=" display-1  mt-3 subpage-heading-1 ">Resilience</div>
              <div class=" headline  mt-3 subpage-heading-2 ">
                Learn about building resilience!
              </div>
            </v-container>
          </div>
        </v-layout>
      </v-parallax>
    </section>
    <section>
      <v-container grid-list-xl class=" white-background">
        <v-layout row wrap align-center>
          <v-flex xs12>
            <v-card class="elevation-0 transparent text-xs-center">
              <h2 class="headline pa-2">Resilience</h2>
              <span class="subheading pa-2">
                What it means for your building</span
              >
            </v-card>

            <div>
              <p class="pl-2 pr-2 pt-2">
                ‘Resilience’ in the context of the Strata Title Inspection
                Program means strength or robustness i.e. the extent to which a
                property can remain mostly undamaged and functional during and
                after a cyclone. The program identifies several resilience
                categories for your property: the resilience of the grounds to
                damage; the resilience of the buildings to damage from wind,
                wind-driven rain and storm tide; and the resilience of items
                attached to the buildings.
              </p>
            </div>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <section>
      <v-container grid-list-xl class="white-background" justify-center>
        <v-layout column wrap justify-start>
          <v-flex xs12>
            <v-layout
              row
              wrap
              align-center
              justify-start
              class="white-background"
            >
              <v-flex xs3>
                <v-img
                  :src="require('@/assets/pool.png')"
                  aspect-ratio="1"
                  max-width="250px"
                ></v-img>
              </v-flex>
              <v-flex xs9>
                <v-layout column align-start justify-start class="pl-3 pr-3">
                  <p class="headline">Grounds Resilience</p>
                  <p>
                    Grounds resilience refers to the ability of different
                    structures or items on the property (not the main
                    building/s) to withstand the wind and storm tide forces
                    generated during a cyclone. Some property elements such as
                    swimming pools can be adversely affected by vegetation blown
                    into the pool and also by storm tide inundation on some
                    properties.
                  </p>
                  <p>
                    The grounds resilience is mostly affected by the number and
                    condition of potentially susceptible items on the property
                    i.e. the larger the number of items and the poorer their
                    condition, the less resilient the property is to damage
                    during a cyclone.
                  </p>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              align-center
              justify-start
              class="white-background"
            >
              <v-flex xs3>
                <v-img
                  :src="require('@/assets/building.png')"
                  aspect-ratio="1"
                  max-width="250px"
                ></v-img>
              </v-flex>
              <v-flex xs9>
                <v-layout column align-start justify-start class="pl-3 pr-3">
                  <p class="headline">Resilience of Buildings</p>
                  <p>
                    Buildings that are resilient will require minimal repairs
                    compared with average buildings. Resilience of buildings is
                    presented as resilience to wind damage, rainwater damage,
                    storm surge damage, and damage to ancillary items on the
                    building.
                  </p>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              align-center
              justify-start
              class="white-background"
            >
              <v-flex xs3>
                <v-img
                  :src="require('@/assets/wind-resilience.png')"
                  aspect-ratio="1"
                  max-width="225px"
                ></v-img>
              </v-flex>
              <v-flex xs9>
                <v-layout column align-start justify-start class="pl-3 pr-3">
                  <p class="headline">Wind Resilience</p>
                  <p>
                    Wind resilience refers to how well the components of a
                    building can resist wind loads and remain mostly undamaged,
                    i.e. parts of the building do not break or detach. Failure
                    of roof or wall cladding or any elements that support the
                    cladding often also allow rainwater to enter the building,
                    which increases the level of damage e.g. loss of part of the
                    roof allows water to damage the ceiling and walls below.
                    Wind resilience estimates the resistance of buildings to
                    damage from wind pressures.
                  </p>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              align-center
              justify-start
              class="white-background"
            >
              <v-flex xs3>
                <v-img
                  :src="require('@/assets/rain-resilience.svg')"
                  aspect-ratio="1"
                  max-width="250px"
                ></v-img>
              </v-flex>
              <v-flex xs9>
                <v-layout column align-start justify-start class="pl-3 pr-3">
                  <p class="headline">Rain Resilience</p>
                  <p>
                    Rain resilience refers to how well building elements can
                    prevent wind driven rain entering a building through windows
                    with inadequate seals, through ceilings from overflowing
                    gutters or inadequately fastened flashings, or though
                    elements that have been damaged by the wind. Wind-driven
                    rain entering buildings can damage ceilings and wall
                    linings. A building that sustains water damage may require
                    expensive repairs even though in some cases there may be
                    little or no obvious wind damage.
                  </p>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              align-center
              justify-start
              class="white-background"
            >
              <v-flex xs3>
                <v-img
                  :src="require('@/assets/wave-resilience.png')"
                  aspect-ratio="1"
                  max-width="250px"
                ></v-img>
              </v-flex>
              <v-flex xs9>
                <v-layout column align-start justify-start class="pl-3 pr-3">
                  <p class="headline">Surge Resilience</p>
                  <p>
                    Surge resilience refers to how well a building can withstand
                    inundation from seawater and the forces generated by rising
                    seawater and pounding waves that can occur during cyclones.
                  </p>
                </v-layout>
              </v-flex>
            </v-layout>

            <v-layout
              row
              wrap
              align-center
              justify-start
              class="white-background"
            >
              <v-flex xs3>
                <v-img
                  :src="require('@/assets/solar-panel.png')"
                  aspect-ratio="1"
                  max-width="250px"
                ></v-img>
              </v-flex>
              <v-flex xs9>
                <v-layout column align-start justify-start class="pl-3 pr-3">
                  <p class="headline">Resilience of building ancillary items</p>
                  <p>
                    Resilience of building ancillary items refers to the
                    resilience of items that are attached to buildings e.g.
                    solar photovoltaic panels, solar hot water systems, air
                    conditioning units, and aerials. Damaged ancillary items
                    must be repaired or replaced and can also cause damage to
                    the building as they detach, or they can become wind-borne
                    debris that can break windows, doors or roof and wall
                    cladding. Resilient ancillary items will remain undamaged
                    during cyclones.
                  </p>
                </v-layout>
              </v-flex>
              <v-flex xs12 class="text-center">
                <v-btn
                        class=" mt-3 mb-3 blue--text "
                        color="blue "
                        dark
                        large
                        outlined
                        @click="gotoTechnical"

                >
                  Learn More About Estimating Resilience
                </v-btn>
              </v-flex>


            </v-layout>
          </v-flex>
        </v-layout>
      </v-container>
    </section>

    <!--<v-footer class="blue darken-2 white&#45;&#45;text">
            <v-layout row wrap align-center>
                <v-flex xs12>
                    <div class="white&#45;&#45;text ml-3">
                        Made in Collaboration With
                        <a class="white&#45;&#45;text" href="https://jcu.edu.au" target="_blank">James Cook University Australia</a>
                        and <a class="white&#45;&#45;text" href="https://jcu.edu.au/cts">Cyclone Testing Station JCU</a>
                    </div>
                </v-flex>
            </v-layout>
        </v-footer>-->
    <Footer></Footer>
  </v-content>
</template>

<style></style>

<script>
import Navbar from "./Navbar.vue";
import Footer from "./Footer.vue";
import { router } from "../router";

export default {
  name: "Resilience",
  components: {
    Navbar,
    Footer
  },
  data: () => ({
    items: [
      {
        color: "#27C5DA",
        icon: "person",
        header: "1. Appoint an Authorised Person",
        text:
          "The Strata body appoints a representative called the Authorised Person.The Authorised Person is someone who has been voted in by the Body Corporate Committee to represent the property."
      },
      {
        color: "#46B3FD",
        icon: "create",
        header: "2. Register",
        text: "Complete the registration form below on the strata portal."
      },
      {
        color: "#4CABDB",
        icon: "cloud_upload",
        header: "3. Request an insepction",
        text:
          "You will be provided with login details. Login to your account. Fill in information about your site. Submit your site for an inspection."
      },
      {
        color: "#27C5DA",
        icon: "view_headline",
        header: "4. Prepare",
        text:
          "Even before your property is assessed, you can undertake measures to improve the resilience of your property to damage from the effects of tropical cyclones."
      },

      {
        color: "#46B3FD",
        icon: "date_range",
        header: "5. Inspection",
        text: "You will be contacted by an Inspector to schedule the inspection"
      },
      {
        color: "#4CABDB",
        icon: "list_alt",
        header: "6. Report",
        text:
          "Your report will include resilience scores and mitigation options."
      },

      {
        color: "#27C5DA",
        icon: "list",
        header: "7. Mitigation",
        text:
          "Strata Body considers resilience and undertakes selected mitigation options, and may communicates with insurer."
      }
    ]
  }),
  methods: {
    gotoTechnical() {
      router.push("/estimating");
    }
  }
};
</script>
